export const fields = {
  textField: {
    hidePassword: "Hide password",
    showPassword: "Show password",
  },
};
